import NotFound from '@/modules/notFound'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/not-found')({
  component: NotFound,
})
